import React, { FC, memo, useState } from 'react'
import StarOutlineIcon from '@ucheba/ui/icons/icon__star-outline.svg'

import { IFeedbackHeader } from '../../../types'

import {
  FeedbackHeaderContainer as Container,
  Controls,
  Stars,
  TextStyled,
  StarFilledIconStyled,
  StarWrapper,
} from '../../../base/styled'

import WhatShouldWriteInReview from './WhatShouldWriteInReview'

const FeedbackHeader: FC<IFeedbackHeader> = ({ sendingLoading, rate, setRate }) => {
  const [currentRate, setCurrentRate] = useState<number>(rate)
  const [showHint, setShowHint] = useState<boolean>(false)

  return (
    <Container>
      {showHint && <WhatShouldWriteInReview />}

      <Controls>
        <Stars>
          {[...Array(5)].map((_, index) => (
            <StarWrapper
              key={index}
              onClick={() => !sendingLoading && setRate(index + 1)}
              onMouseOver={() => !sendingLoading && setCurrentRate(index + 1)}
              onMouseLeave={() => !sendingLoading && setCurrentRate(rate)}
            >
              {currentRate >= index + 1 ? <StarFilledIconStyled /> : <StarOutlineIcon />}
            </StarWrapper>
          ))}
        </Stars>

        {!showHint && (
          <TextStyled
            onClick={() => setShowHint(true)}
            fontWeight='bold'
            fontSize='h4'
            color='blue'
          >
            О чем писать?
          </TextStyled>
        )}
      </Controls>
    </Container>
  )
}

export default memo(FeedbackHeader)
